import axios from 'axios';

import { API_URL } from '../config';

// Create axios instance with default config
const api = axios.create({
    baseURL: API_URL,
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    }
});

export interface Feed {
  id: number;
  content: string;
  created_at: string;
  type?: string;
  description?: string;
  materials_used?: string;
  project: {
    id: number;
    name: string;
  };
  employee: {
    id: number;
    name: string;
    surname: string;
    imageUrl: string;
    /** 800px copy of the profile photo; missing on older backends */
    thumbnailUrl?: string;
  };
  user: {
    id: number;
    name: string;
    employee: {
      id: number;
      name: string;
      surname: string;
      imageUrl: string;
      thumbnailUrl?: string;
    };
  };
  imageUrls: string[];
  /** 800px WebP copies in the same order as imageUrls — what grids should show.
   *  Falls back to the full image for uploads from before the image pipeline. */
  thumbnailUrls?: string[];
}

export interface PaginatedFeeds {
  data: Feed[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface FeedsResponse {
  message: string;
  feeds: PaginatedFeeds;
}

class FeedService {
  async getTodaysFeeds(projectId?: number): Promise<Feed[]> {
    const params = projectId ? { project_id: projectId } : {};
    const response = await api.get<{ message: string; feeds: Feed[] }>(`/feeds/today`, { params });
    return response.data.feeds;
  }

  async getAllFeeds(projectId?: number, page: number = 1): Promise<PaginatedFeeds> {
    const params = {
      ...(projectId ? { project_id: projectId } : {}),
      page
    };
    const response = await api.get<FeedsResponse>('/feeds', { params });
    return response.data.feeds;
  }

  async deleteFeed(id: number): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/feeds/${id}`);
    return response.data;
  }
}

export const feedService = new FeedService(); 